if (!customElements.get("collection-merchandiser")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.tabInterface = document.querySelector("tab-interface");
    }

    connectedCallback() {
      this.tabInterface && (this.hasProductViewTracking = this.hasAttribute("data-product-view-tracking"), this.defaultProduct = sessionStorage.getItem("product-view"), this.tabInterface.addEventListener("tabChange", this.tabChangeListener.bind(this)));
    }

    tabChangeListener(t) {
      this.onTabChange(t), requestAnimationFrame((() => {
        this.hasProductViewTracking && null !== this.defaultProduct && this.setDefaultTab(this.defaultProduct);
      }));
    }

    onTabChange(t) {
      const { tabpanel: e } = t.detail, a = e.querySelectorAll("img[data-src]");
      "function" == typeof imageLazyLoader ? imageLazyLoader(a) : (console.error("⚠️ Global Image lazy loader function not found."), a.forEach((t => {
        if (t.classList.contains("lazy-loading")) {
          const e = new Image;
          e.srcset = t.dataset.srcset, e.onload = () => {
            t.srcset = t.dataset.srcset, t.src = t.dataset.src, t.removeAttribute("data-src"), t.removeAttribute("data-srcset"), t.classList.remove("lazy-loading");
          };
        }
      })));
    }

    setDefaultTab(t) {
      if (null !== this.defaultProduct && this.hasProductViewTracking) {
        const e = Array.from(this.querySelectorAll("[role=\"tab\"]")).find((e => e.dataset.products.includes(t)));
        e && this.tabInterface && "function" == typeof this.tabInterface.setSelectedTab && (this.defaultProduct = null, sessionStorage.removeItem("product-view"), this.tabInterface.setSelectedTab(e));
      }
    }
  }

  customElements.define("collection-merchandiser", t);
}